import React from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";

const COLORS = ["#3b3b3b", "#1F77B4", "#72A0C1"]; // You can customize this

const SimplePercentagePieChart = ({ height = 250, data }) => (
  <ResponsiveContainer width="100%" height={height} className="p-2 pb-2">
    <PieChart>
      <Tooltip formatter={(value) => `${value}%`} />
      <Legend verticalAlign="bottom" />
      <Pie
        data={data}
        dataKey="value"
        nameKey="name"
        cx="50%"
        cy="50%"
        outerRadius={80}
        label={({ name, percent }) =>
          `${name}: ${Math.round(percent * 100)}%`
        }
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS?.length]} />
        ))}
      </Pie>
    </PieChart>
  </ResponsiveContainer>
);

export default SimplePercentagePieChart;